import type { StoreListItem } from "@/types/filters";

export function formatZipcode(zipcode: string) {
  if (zipcode.length !== 8) {
    return "";
  }
  return zipcode.slice(0, 5) + "-" + zipcode.slice(5);
}

export const formattedTime = (timeString: string) =>
  timeString.replace(/^(\d{2}):(\d{2}):\d{2}\.\d{3}$/, "$1h$2");

export const formattedTimeGlobal = (timeString: string) =>
  timeString.replace(/^(\d{2}):(\d{2}):\d{2}\.\d{3}$/, "$1:$2");

export const validateZipcode = (zipcode: string) => {
  return /^[0-9]{5}-[0-9]{3}$/.test(zipcode);
};

export const orderStoresDefault = (storeList: StoreListItem[]) => {
  const sortedStoreList = storeList
    .sort((a, b) => {
      if (a.name >= b.name) return 1;
      return -1;
    })
    .map((item) => item);

  return sortedStoreList;
};

export const removeAccents = (str: string) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const scrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};
